import StorageOptionFull from './components/StorageOptionFull';
import * as React from 'react';
import { getUserConfiguration } from 'owa-session-store';
var StorageOption = {
    key: 'mailboxStorage',
    titleStringKey: 'optionTitle_storage',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_storage',
    fullOptionFormSettings: {
        render: function () { return React.createElement(StorageOptionFull, { isPremium: false }); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () { return getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox; },
};
export default StorageOption;
//# sourceMappingURL=StorageOption.js.map